<template>
  <div>
    <video
      v-show="adList[adIndex].type !== 'image'"
      id="video" class="ad-video" autoplay
      poster="images/loading.png"
      @play="handlePlay"
    >
      <source :src="adList[adIndex].url" type="video/mp4" />
    </video>
    <img
      v-show="adList[adIndex].type === 'image'"
      :src="adList[adIndex].url"
      class="ad-image"
    />
  </div>
</template>

<script>
export default {
  props: ['ad-list', 'ad-index'],
  name: 'adVideo',
  components: {
  },
  methods: {
    handlePlay (event) {
      console.log('[adVideo] 비디오 재생 시작', {
        timestamp: new Date().toISOString(),
        adIndex: this.adIndex,
        url: this.adList[this.adIndex].url,
        type: this.adList[this.adIndex].type
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/style.scss";

.ad-video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.ad-image {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
}

</style>
